import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ShareRecordsMutation,
  ShareRecordsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const shareRecordsDocument = graphql(`
  mutation shareRecords($input: ShareRecordsRequest!) {
    shareRecords(input: $input)
  }
`);

export function useShareNotice(
  options?: UseMutationOptions<
    ShareRecordsMutation,
    unknown,
    ShareRecordsMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(shareRecordsDocument, options);
}
